<script lang="ts" setup>
defineOptions({
  inheritAttrs: false,
});

defineProps<{
  isPageHeading?: boolean;
}>();
</script>

<template>
  <div class="flex w-full flex-col leading-none">
    <span
      v-if="$slots.subheading"
      class="-mb-0.5 font-subheading text-sm font-bold tracking-wider text-green-200"
      ><slot name="subheading" /><br
    /></span>

    <component
      :is="isPageHeading ? 'h1' : 'h2'"
      class="w-fit gap-1 font-heading text-xl font-extrabold uppercase leading-normal tracking-wide"
      v-bind="$attrs"
    >
      <slot />
    </component>
  </div>
</template>

<style scoped></style>
